import React from 'react';
import { connect } from 'react-redux';
import Breadcrumbs from '../../../UI/Breadcrumbs';
import WidgetsConstructor from './pages/WidgetsConstructor';

const WidgetConstructor = ({event}) => {
    const breadcrumbs = [
        'mainMenu.widgets',
        'mainMenu.widget.registrationConstructor',
    ];

    return (
        <section>
            <Breadcrumbs
                link={`/event/${event.eventPassword}`}
                activeCrumbs={breadcrumbs}
            />

            <WidgetsConstructor event={event} />
        </section>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(WidgetConstructor);
